module.exports = __webpack_public_path__ + "img/Alkitabiah-logo.46d5dfe5.png";